import * as Yup from 'yup'

export const getInitialValues = assignment => ({
  manager: assignment?.manager
    ? {
        label: `${assignment.manager.firstName} ${assignment.manager.lastName}`,
        value: assignment.manager.id
      }
    : null,
  delegate: assignment?.delegate
    ? {
        label: `${assignment.delegate.firstName} ${assignment.delegate.lastName}`,
        value: assignment.delegate.id
      }
    : null
})

export const getAssignmentValidationSchema = () => {
  return Yup.object().shape({
    manager: Yup.object()
      .shape({
        label: Yup.string().required('This field is required.'),
        value: Yup.string().required('This field is required.')
      })
      .required('This field is required.'),
    delegate: Yup.object()
      .shape({
        label: Yup.string().nullable(),
        value: Yup.string().nullable()
      })
      .nullable()
  })
}
